import type { AniChatWidgetContextValue } from "@/context/AniContext";

export interface ChatContextConfig {
  isActive: boolean;
  initialAssistantMessage: string;
  samplePrompts: string[];
}

export type ChatContextConfigs = {
  [K in Exclude<AniChatWidgetContextValue, undefined>]: ChatContextConfig;
};

// Default configurations for each context
export const defaultChatContextConfigs: ChatContextConfigs = {
  dashboard: {
    isActive: false,
    initialAssistantMessage: "Ani for dashboards coming soon.",
    samplePrompts: [],
  },
  scenarios: {
    isActive: true,
    initialAssistantMessage:
      "I can help you analyze and understand your scenarios. What would you like to know?",
    samplePrompts: [
      "Compare my best and worst case scenarios",
      "What assumptions drive the most variance?",
      "Show me sensitivity analysis",
    ],
  },
  documents: {
    isActive: false,
    initialAssistantMessage: "Ani for documents coming soon.",
    samplePrompts: [],
    // initialAssistantMessage: "I can help you query and analyze your documents. What would you like to know?",
    // samplePrompts: [
    //   "Summarize the key points from the latest factsheet",
    //   "What are the main risks mentioned in the document?",
    //   "Compare the performance metrics across my documents",
    // ],
  },
  "cash-flow": {
    isActive: false,
    initialAssistantMessage: "Ani for cash flow coming soon.",
    samplePrompts: [],
  },
  pod: {
    isActive: false,
    initialAssistantMessage: "Ani for pods coming soon.",
    samplePrompts: [],
  },
  screener: {
    isActive: false,
    initialAssistantMessage: "Ani for screener coming soon.",
    samplePrompts: [],
  },
  playground: {
    isActive: false,
    initialAssistantMessage: "Ani for playground coming soon.",
    samplePrompts: [],
  },
  product: {
    isActive: false,
    initialAssistantMessage: "Ani for product coming soon.",
    samplePrompts: [],
  },
  portfolio: {
    isActive: false,
    initialAssistantMessage: "I can help you understand and analyze your portfolio. What would you like to know?",
    samplePrompts: [],
  },
  worker: {
    isActive: false,
    initialAssistantMessage: "Ani for workers coming soon.",
    samplePrompts: [],
  },
  "report-builder": {
    isActive: false,
    initialAssistantMessage: "I can help you build and customize your reports. What would you like to know?",
    samplePrompts: [],
  },
  "case-checking": {
    isActive: true,
    initialAssistantMessage:
      "I can help with compliance case status — ask which cases are processing or what's blocking a file.",
    samplePrompts: [
      "Which cases are still processing?",
      "What's the status of this case?",
      "Why is this case blocked?",
    ],
  },
};
